import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import GoodsLoanLayer from "../../../components/Admin/GoodsLoanLayer";

const GoodsLoan = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <GoodsLoanLayer />
      </MasterLayout>
    </>
  );
};

export default GoodsLoan;